import { createSvgComponent } from "../../icon/createSvgComponent";
import Bulletlist from "@core/__generated__/icon/figma/bulletlist.svg";
export default createSvgComponent(Bulletlist);